import React, { useState, useEffect } from "react";
import axios from "axios";

const CenterPage = () => {
  const [form, setForm] = useState({
    centerName: "",
    status: "Active",       // ✅ new
    createdDate: "",        // ✅ auto on create
    pauseDate: "",          // ✅ optional
    ownerName: "",          // ✅ new
    ownerEmail: "",         // ✅ new
    centerAddress: "",      // ✅ new
  });

  const [list, setList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editId, setEditId] = useState(null);

  // ✅ Fetch all centers on load
  useEffect(() => {
    fetchCenters();
  }, []);

  const fetchCenters = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/centers");
      setList(res.data);
    } catch (err) {
      console.error("❌ Error fetching centers:", err);
    }
  };

  // ✅ Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  // ✅ Save new center
  const handleSave = async () => {
    if (!form.centerName) {
      alert("⚠️ Please enter center name");
      return;
    }
    const payload = {
      ...form,
      createdDate: new Date().toISOString(), // set current date/time
    };
    try {
      const res = await axios.post("https://crm-server-htk6.vercel.app/api/centers", payload);
      if (res.data.success) {
        alert("✅ Center saved successfully");
        fetchCenters();
        resetForm();
      }
    } catch (err) {
      console.error("❌ Error saving center:", err);
    }
  };

  // ✅ Edit center
  const handleEdit = (row) => {
    setForm({
      centerName: row.centerName || "",
      status: row.status || "Active",
      createdDate: row.createdDate || "",
      pauseDate: row.pauseDate || "",
      ownerName: row.ownerName || "",
      ownerEmail: row.ownerEmail || "",
      centerAddress: row.centerAddress || "",
    });
    setEditId(row._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Update center
  const handleUpdate = async () => {
    if (!form.centerName) {
      alert("⚠️ Please enter center name");
      return;
    }
    try {
      await axios.put(`https://crm-server-htk6.vercel.app/api/centers/${editId}`, form);
      alert("✨ Center updated successfully");
      fetchCenters();
      resetForm();
    } catch (err) {
      console.error("❌ Error updating center:", err);
    }
  };

  // ✅ Reset form
  const resetForm = () => {
    setForm({
      centerName: "",
      status: "Active",
      createdDate: "",
      pauseDate: "",
      ownerName: "",
      ownerEmail: "",
      centerAddress: "",
    });
    setEditId(null);
  };

  // ✅ Delete single center
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this center?")) return;
    try {
      await axios.delete(`https://crm-server-htk6.vercel.app/api/centers/${id}`);
      fetchCenters();
      setSelected((prev) => prev.filter((s) => s !== id));
    } catch (err) {
      console.error("❌ Error deleting center:", err);
    }
  };

  // ✅ Bulk delete
  const handleBulkDelete = async () => {
    if (selected.length === 0) {
      alert("⚠️ Please select at least one center to delete");
      return;
    }
    if (!window.confirm(`Delete ${selected.length} selected centers?`)) return;

    try {
      await axios.delete("https://crm-server-htk6.vercel.app/api/centers", {
        data: { ids: selected },
      });
      setSelected([]);
      fetchCenters();
    } catch (err) {
      console.error("❌ Error bulk deleting centers:", err);
    }
  };

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(list.map((row) => row._id));
    } else {
      setSelected([]);
    }
  };

  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>Center Management</h2>

      {/* ---------- FORM ---------- */}
      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>
          {editId ? "✏️ Update Center" : "➕ Add New Center"}
        </h3>

        <div className="form-row" style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
          <input
            type="text"
            name="centerName"
            placeholder="Center Name"
            value={form.centerName}
            onChange={handleChange}
            style={{ flex: "1 1 200px", padding: "8px" }}
          />

          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            style={{ flex: "1 1 150px", padding: "8px" }}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>

          <input
            type="date"
            name="pauseDate"
            placeholder="Pause Date"
            value={form.pauseDate}
            onChange={handleChange}
            style={{ flex: "1 1 200px", padding: "8px" }}
          />

          <input
            type="text"
            name="ownerName"
            placeholder="Center Owner Name"
            value={form.ownerName}
            onChange={handleChange}
            style={{ flex: "1 1 200px", padding: "8px" }}
          />

          <input
            type="email"
            name="ownerEmail"
            placeholder="Center Email"
            value={form.ownerEmail}
            onChange={handleChange}
            style={{ flex: "1 1 200px", padding: "8px" }}
          />

          <input
            type="text"
            name="centerAddress"
            placeholder="Center Address"
            value={form.centerAddress}
            onChange={handleChange}
            style={{ flex: "1 1 300px", padding: "8px" }}
          />
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button
            onClick={editId ? handleUpdate : handleSave}
            style={{
              background: editId ? "#e9c46a" : "#2a9d8f",
              color: "white",
              padding: "10px 16px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              flex: 1,
            }}
          >
            {editId ? "✏️ Update Center" : "💾 Save Center"}
          </button>

          {editId && (
            <button
              onClick={resetForm}
              style={{
                background: "#e63946",
                color: "white",
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                flex: 1,
              }}
            >
              ❌ Cancel
            </button>
          )}
        </div>
      </div>

      {/* ---------- TABLE ---------- */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h3 style={{ margin: 0 }}>📋 Center List</h3>
        <button
          onClick={handleBulkDelete}
          style={{
            background: selected.length > 0 ? "#e63946" : "gray",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: selected.length > 0 ? "pointer" : "not-allowed",
          }}
          disabled={selected.length === 0}
        >
          🗑 Delete Selected ({selected.length})
        </button>
      </div>

      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={list.length > 0 && selected.length === list.length}
                />
              </th>
              <th>Center Name</th>
              <th>Status</th>
              <th>Created Date</th>
              <th>Pause Date</th>
              <th>Owner Name</th>
              <th>Email</th>
              <th>Address</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
                  No records found
                </td>
              </tr>
            ) : (
              list.map((row) => (
                <tr key={row._id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selected.includes(row._id)}
                      onChange={() => toggleSelect(row._id)}
                    />
                  </td>
                  <td>{row.centerName}</td>
                  <td>{row.status}</td>
                  <td>
                    {row.createdDate
                      ? new Date(row.createdDate).toLocaleDateString()
                      : ""}
                  </td>
                  <td>
                    {row.pauseDate
                      ? new Date(row.pauseDate).toLocaleDateString()
                      : ""}
                  </td>
                  <td>{row.ownerName}</td>
                  <td>{row.ownerEmail}</td>
                  <td>{row.centerAddress}</td>
                  <td style={{ textAlign: "center" }}>
                    <button
                      onClick={() => handleEdit(row)}
                      style={{
                        background: "#457b9d",
                        color: "white",
                        border: "none",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        marginRight: "6px",
                      }}
                    >
                      ✏️ Edit
                    </button>
                    <button
                      onClick={() => handleDelete(row._id)}
                      style={{
                        background: "#e63946",
                        color: "white",
                        border: "none",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      🗑 Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CenterPage;
